import { Columns } from '@domain-group/suit-theme'

import useProvider from '@hooks/useProvider'

import PageLayout from '../../../../components/PageLayout'

import AddressDetails from '../AddressDetails'
import ContactDetails from '../ContactDetails'
import ProviderDetails from '../ProviderDetails'

interface PageContentProps {
  providerId: number,
}

const PageContent = (props: PageContentProps) => {
  const { providerId } = props

  const providerPayload = useProvider({ id: providerId })
  const { providerSalesforceDetails } = providerPayload

  return (
    <PageLayout activeTabBarItemKey="salesforceDetails" entityPayload={providerPayload}>
      <Columns.Main>
        {/*
         // @ts-expect-error TS2740 */}
        <ProviderDetails providerSalesforceDetails={providerSalesforceDetails} />

        {/*
         // @ts-expect-error TS2322 */}
        <ContactDetails providerSalesforceDetails={providerSalesforceDetails} />

        {/*
         // @ts-expect-error TS2322 */}
        <AddressDetails providerSalesforceDetails={providerSalesforceDetails} />
      </Columns.Main>
    </PageLayout>
  )
}

export default PageContent
